import React, { FC } from 'react';
import * as yup from 'yup';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormText } from 'components/form';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import FeedRoundedIcon from '@mui/icons-material/FeedRounded';

// Define the form data shape
interface AppValuesForm {
  seniorCost: number;
  juniorCost: number;
}

// Validation schema
const schema = yup
  .object()
  .shape({
    seniorCost: yup.number().min(0).required(),
    juniorCost: yup.number().min(0).required(),
  })
  .required();

export const AppValues: FC = () => {
  // Initialize form
  const {
    handleSubmit,
    control,
    formState: { isDirty, errors },
  } = useForm<AppValuesForm>({
    mode: 'onChange',
    defaultValues: {
      seniorCost: 1290,
      juniorCost: 995,
    },
    resolver: yupResolver(schema),
  });

  // Submit handler
  const onSubmit: SubmitHandler<AppValuesForm> = (data) => {
    console.log('App Values saved:', data);
    // TODO: call API or state update
  };

  return (
    <Grid item xs={12}>
      <form onSubmit={handleSubmit(onSubmit)} name="appValuesForm">
        <Paper
          sx={{ mb: 2, borderRadius: 3, backgroundColor: 'primary.main', color: 'primary.text' }}
        >
          <Accordion
            expanded
            disableGutters
            elevation={0}
            sx={{ m: 0, backgroundColor: 'transparent', boxShadow: 0, border: 0 }}
          >
            <AccordionSummary aria-controls="panel-content" id="panel-header">
              <Box sx={{ pt: 1 }}>
                <FeedRoundedIcon sx={{ fontSize: 40 }} />
              </Box>
              <Box sx={{ pl: 2, pt: 2, flexGrow: 1 }}>
                <Typography noWrap variant="h6">
                  App Values
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ p: 3 }}>
                <Grid item xs={6}>
                  <FormText
                    name="seniorCost"
                    control={control}
                    label="Senior Hour Price"
                    error={!!errors.seniorCost}
                    helperText={errors.seniorCost?.message}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormText
                    name="juniorCost"
                    control={control}
                    label="Junior Hour Price"
                    error={!!errors.juniorCost}
                    helperText={errors.juniorCost?.message}
                  />
                </Grid>
              </Grid>

              <Box sx={{ m: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="submit" variant="contained" disabled={!isDirty}>
                  Save
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Paper>
      </form>
    </Grid>
  );
};
